module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "link link-rep",
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    staticClass: "rep-circle"
  }, [_vm._v("+3")]), _vm._v(" "), _c('span', {
    staticClass: "info"
  }, [_c('span', [_vm._v("Enjoying your conversation?")]), _c('span', {
    staticClass: "text"
  }, [_vm._v("Give " + _vm._s(_vm.user.firstname) + " +3 Reputation")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a28842aa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/chat/conversation/GiveReputation.vue
// module id = 728
// module chunks = 1